export const SNOWPACK_PUBLIC_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_REV = "0235b47";
export const SNOWPACK_PUBLIC_VERSION = "0.42.0";
export const SNOWPACK_PUBLIC_WHALESPLAINER_URL = "https://create.anchor.tools";
export const SNOWPACK_PUBLIC_UNICOVE_URL = "https://banxa-integration-v2.wallet-2tl.pages.dev";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;